(() => {
    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: false
        },
        on: {
            init: function () {
                const pagination = this.pagination.el;
                if (pagination && this.params.pagination.type === "progressbar") {
                    pagination.dataset.current = this.slides[this.activeIndex].dataset.index || this.realIndex + 1;
                    const rect = pagination.getBoundingClientRect();
                    pagination.addEventListener("click", (e) => {
                        this.slideToLoop(Math.floor((e.clientX - rect.left) / (rect.width / this.slides.length)));
                    });
                }
            },
            slideChange: function () {
                if (this.pagination.el)
                    this.pagination.el.dataset.current = this.slides[this.activeIndex].dataset.index || this.realIndex + 1;

                const syncing = this.params.syncing;

                if (syncing && document.getElementById(syncing) && document.getElementById(syncing).swiper)
                    document.getElementById(syncing).swiper.slideToLoop(this.realIndex);
            }
        }
    };

    document.querySelectorAll(".swiper-slider").forEach(slider => {
        new Swiper(slider, Object.assign({}, defaultSettings, slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {}));
    });

    // Gallery slider
    const galleryThreeImages = document.querySelectorAll('.gallery-three-images-block_slider');

    if(galleryThreeImages) {
        const galleryThreeImagesSlider = new Swiper(".gallery-three-images-block_slider", {
            autoplay: {
                delay: 7000,
            },
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 33,
            navigation: {
                nextEl: ".gallery-three-images-block_slider--next",
                prevEl: ".gallery-three-images-block_slider--prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            }
        });
    }

    // Cards Slider
    const cards = document.querySelectorAll(".cards-slider");

    if(cards) {
        const cardsSlider = new Swiper(".cards-slider", {
            autoplay: {
                delay: 7000,
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: ".cards-slider-next",
                prevEl: ".cards-slider-prev",
            }
        });
    }

    // Slider Images
    const sliderImagesBlock = document.querySelector(".slider-image-swiper");

    if(sliderImagesBlock) {
        const sliderImages = new Swiper(".slider-image-swiper", {
            autoplay: {
                delay: 5000,
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: ".slider-images-next",
                prevEl: ".slider-images-prev",
            }
        });
    }
})();